const welcome_banners_en = require('./welcome_banners.json')
export default welcome_banners_en